module.exports = __webpack_public_path__ + "media/src/img/children-left-deco-0bca520891cc5e819b5fe5a11927c52d.png";